module.exports = __webpack_public_path__ + "static/img/320.c4aa9ac6.jpg";